export default __webpack_public_path__ + "assets/images/3.b469a0.png";